import { Injectable } from "@angular/core";
import { BehaviorSubject } from "rxjs";
import { GetUserPermissionGQL } from '../generated/cloudapigql';
import { AuthenticationService } from './authentication.service';

@Injectable()
export class ACLService {
  private permissionList = [];
  currentUserPermission = new BehaviorSubject<any>({});
  constructor(
    private getUserPermissionGQL: GetUserPermissionGQL,
    private authService: AuthenticationService,
  ) {
    // this.initUserPermissionData();
  }

  initUserPermissionData() {
    this.currentUserPermission.next(null);
    this.permissionList = [];
    this.getUserPermissionGQL
    .fetch()
    .subscribe((result) => {
        if (result.errors) {
            this.currentUserPermission.next(null);
        } else {
            let permission = Array.from(new Set(result.data.getUserRoleByUserId.flatMap(x=>x.permissions.map(x=>x.permissionCode))));
            this.currentUserPermission.next(permission);
            this.permissionList = permission;
        }
    });
  }

  userPermissionChecking(permissions:string[]){
    if(this.authService.userContext.isSuperUser){
      return true;
    }
    return this.permissionList.some(x=> permissions.some(y=>y == x))
  }

}
